import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Column } from 'primereact/column'
import { InputText as PrimeInputText } from 'primereact/inputtext'

import {
  Btn,
  Cnpj,
  CustomDataTable,
  CustomDropdown,
  CustomInputTextArea,
  CustomModal,
  Loading,
} from '../../../../../components'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { showMessageBox } from '../../../../../store/actions/system.actions'
import { errorHandler } from '../../../../../services/util/error.service'
import { getUsuarioInfo } from '../../../../../services/localstorage/localstorage.service'
import * as ClientHttp from '../../../../../services/api/https/registration/client.http'
import PainelMonitoramentoEntregasHttp from '../../../../../services/api/https/dashboard/painel-monitoramento-entregas.http'

import './OcorrenciasEntrega.css'

export const SEM_OCORRENCIAS_EMPRESA_MESSAGE =
  'Não existe ocorrências de entrega cadastradas para a empresa da Entrega'

/**
 * Cadastro/consulta das Ocorrências de Entrega de uma entrega.
 * Usado como conteúdo da aba "Ocorrências Entrega" do Painel de Monitoramento de Entregas
 * e, através do ModalOcorrenciasEntrega, nas telas de apuração de retorno de veículo.
 */
function OcorrenciasEntrega({ deliveryStepVehicleId, fleetId, onOcorrenciasVistas, dispatch }) {
  const [ocorrencias, setOcorrencias] = useState([])
  const [ocorrenciasEntrega, setOcorrenciasEntrega] = useState([])
  const [loading, setLoading] = useState(false)
  const [loaded, setLoaded] = useState(false)
  const [ocorrenciaModal, setOcorrenciaModal] = useState(createOcorrenciaModalState())

  const fetchOcorrenciasEntrega = useCallback(async () => {
    if (!deliveryStepVehicleId) {
      setLoaded(true)
      return []
    }

    try {
      setLoading(true)
      const data =
        await PainelMonitoramentoEntregasHttp.getOcorrenciasEntrega(deliveryStepVehicleId)

      setOcorrencias(data.ocorrencias || [])
      setOcorrenciasEntrega(data.ocorrencias_delivery || [])
      setLoaded(true)

      if (onOcorrenciasVistas) onOcorrenciasVistas(deliveryStepVehicleId)

      if (!data.ocorrencias || data.ocorrencias.length === 0) {
        dispatch(showMessageBox(null, SEM_OCORRENCIAS_EMPRESA_MESSAGE))
      }

      return data.ocorrencias || []
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
      setOcorrencias([])
      setOcorrenciasEntrega([])
      setLoaded(true)
      return []
    } finally {
      setLoading(false)
    }
  }, [deliveryStepVehicleId, dispatch, onOcorrenciasVistas])

  useEffect(() => {
    if (!loaded && !loading) fetchOcorrenciasEntrega()
  }, [fetchOcorrenciasEntrega, loaded, loading])

  const openOcorrenciaModal = async ocorrenciaEntrega => {
    let ocorrenciasAtuais = ocorrencias
    if (!loaded) {
      ocorrenciasAtuais = await fetchOcorrenciasEntrega()
    }

    if (ocorrenciasAtuais.length === 0) {
      dispatch(showMessageBox(null, SEM_OCORRENCIAS_EMPRESA_MESSAGE))
      return
    }

    const selectedOcorrencia = ocorrenciaEntrega
      ? ocorrenciasAtuais.find(item => item.id === ocorrenciaEntrega.ocorrencia_id)
      : null

    setOcorrenciaModal({
      visible: true,
      row: ocorrenciaEntrega || null,
      selectedOcorrencia: selectedOcorrencia || null,
      observacao: ocorrenciaEntrega ? ocorrenciaEntrega.observacao || '' : '',
      selectedClient:
        ocorrenciaEntrega && ocorrenciaEntrega.guilty_client
          ? {
              id: ocorrenciaEntrega.guilty_client,
              nomeFantasia: ocorrenciaEntrega.guilty_client_name,
            }
          : null,
      showClientModal: false,
    })
  }

  const closeOcorrenciaModal = () => {
    setOcorrenciaModal(createOcorrenciaModalState())
  }

  const saveOcorrenciaEntrega = async () => {
    try {
      const selectedOcorrencia = ocorrenciaModal.selectedOcorrencia
      if (!selectedOcorrencia) throw Error('Selecione uma Ocorrência')
      if (selectedOcorrencia.assoc_guilty_client && !ocorrenciaModal.selectedClient) {
        throw Error('Associe um cliente para salvar esta ocorrência')
      }

      const usuario = getUsuarioInfo()
      const data = await PainelMonitoramentoEntregasHttp.saveOcorrenciaEntrega(
        deliveryStepVehicleId,
        {
          id: ocorrenciaModal.row ? ocorrenciaModal.row.id : null,
          ocorrencia_id: selectedOcorrencia.id,
          observacao: ocorrenciaModal.observacao,
          registred_by: usuario.id,
          guilty_client: ocorrenciaModal.selectedClient ? ocorrenciaModal.selectedClient.id : null,
        },
      )

      setOcorrenciasEntrega(data.ocorrencias_delivery || [])
      closeOcorrenciaModal()
      dispatch(showMessageBox('Operação Realizada com Sucesso', null))
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }

  return (
    <>
      {loading || !loaded ? (
        <div className="ocorrencias-entrega__loading">
          <Loading />
        </div>
      ) : (
        <div className="ocorrencias-entrega__tab">
          <div>
            <Btn onClick={() => openOcorrenciaModal(null)} style={{ marginBottom: 12 }}>
              Novo
            </Btn>
          </div>

          <div className="ocorrencias-entrega__section-label">
            Ocorrências de Entrega cadastradas:
          </div>

          <CustomDataTable
            value={ocorrenciasEntrega}
            emptyMessage="Não existe ocorrência de entrega associada a esta entrega"
            selectionMode="single"
            onRowClick={event => openOcorrenciaModal(event.data)}
            style={{ cursor: 'pointer' }}
          >
            <Column field="descricao" header="Descricao" />
            <Column field="sigla" header="Sigla" style={tableCellCentered(120)} />
            <Column field="codigo_interno" header="Código Interno" style={tableCellCentered(160)} />
            <Column field="observacao" header="Observação" />
          </CustomDataTable>
        </div>
      )}

      <ModalOcorrenciaEntrega
        state={ocorrenciaModal}
        ocorrencias={ocorrencias}
        fleetId={fleetId}
        onChange={setOcorrenciaModal}
        onClose={closeOcorrenciaModal}
        onSave={saveOcorrenciaEntrega}
      />
    </>
  )
}

function ModalOcorrenciaEntrega({ state, ocorrencias, fleetId, onChange, onClose, onSave }) {
  const selectedOcorrencia = state.selectedOcorrencia
  const showAssociarCliente = selectedOcorrencia && selectedOcorrencia.assoc_guilty_client

  const updateState = patch => onChange(prev => ({ ...prev, ...patch }))

  return (
    <>
      <CustomModal
        isVisible={state.visible}
        header="Ocorrência de Entrega"
        width="min(720px, 94vw)"
        onClose={onClose}
      >
        <div className="ocorrencias-entrega__modal-content">
          <div className="ocorrencias-entrega__form">
            <CustomDropdown
              showLabel
              filter
              label="Ocorrência"
              optionLabel="label"
              options={ocorrencias}
              value={selectedOcorrencia}
              onChange={value =>
                updateState({
                  selectedOcorrencia: value,
                  selectedClient: value && value.assoc_guilty_client ? state.selectedClient : null,
                })
              }
              placeholder="Selecione..."
            />

            {showAssociarCliente && (
              <div className="ocorrencias-entrega__assoc-client-block">
                <div>
                  <Btn minWidth={null} onClick={() => updateState({ showClientModal: true })}>
                    Associar Clientes
                  </Btn>
                </div>
                {state.selectedClient ? (
                  <div className="ocorrencias-entrega__cliente-associado">
                    {state.selectedClient.nomeFantasia ||
                      state.selectedClient.name ||
                      'Cliente associado'}
                  </div>
                ) : (
                  <div className="ocorrencias-entrega__empty-state">Nenhum cliente associado</div>
                )}
              </div>
            )}

            <CustomInputTextArea
              label="Observação"
              value={state.observacao}
              onChange={value => updateState({ observacao: value })}
              rows={4}
            />

            <div className="ocorrencias-entrega__modal-footer">
              <Btn onClick={onSave}>Salvar</Btn>
            </div>
          </div>
        </div>
      </CustomModal>

      <ModalAssociarClienteOcorrencia
        visible={state.showClientModal}
        fleetId={fleetId}
        clienteAssociado={state.selectedClient}
        onClose={() => updateState({ showClientModal: false })}
        onSave={cliente => updateState({ selectedClient: cliente, showClientModal: false })}
      />
    </>
  )
}

function ModalAssociarClienteOcorrencia({ visible, fleetId, clienteAssociado, onClose, onSave }) {
  const [clientes, setClientes] = useState([])
  const [clienteSelecionado, setClienteSelecionado] = useState(null)
  const [globalFilter, setGlobalFilter] = useState('')
  const [loadError, setLoadError] = useState(null)

  useEffect(() => {
    if (!visible) return

    setClienteSelecionado(clienteAssociado || null)
    setGlobalFilter('')
    setLoadError(null)

    ClientHttp.getClientsByFleetId(fleetId)
      .then(data => setClientes(data))
      .catch(error => setLoadError(errorHandler(error)))
  }, [clienteAssociado, fleetId, visible])

  const tableHeader = (
    <div className="ocorrencias-entrega__table-header">
      <i className="pi pi-search" />
      <PrimeInputText
        type="search"
        onInput={event => setGlobalFilter(event.target.value)}
        placeholder="Pesquisar . . ."
      />
    </div>
  )

  return (
    <CustomModal
      isVisible={visible}
      header="Associar Cliente a Ocorrência"
      width="min(900px, 94vw)"
      onClose={onClose}
    >
      <div className="ocorrencias-entrega__modal-content">
        <div className="ocorrencias-entrega__section-label">Cliente associado:</div>
        {clienteSelecionado ? (
          <div className="ocorrencias-entrega__cliente-associado ocorrencias-entrega__cliente-associado--spread">
            <span>{clienteSelecionado.nomeFantasia}</span>
            <Btn minWidth={null} onClick={() => setClienteSelecionado(null)}>
              Desassociar
            </Btn>
          </div>
        ) : (
          <div className="ocorrencias-entrega__empty-state">Nenhum cliente associado</div>
        )}

        {loadError && <div className="ocorrencias-entrega__error">{loadError}</div>}

        <CustomDataTable
          value={clientes}
          paginator
          rows={6}
          header={tableHeader}
          globalFilter={globalFilter}
          selectionMode="single"
          onRowClick={event => setClienteSelecionado(event.data)}
          style={{ cursor: 'pointer' }}
        >
          <Column field="nomeFantasia" header="Nome Fantasia" />
          <Column
            field="cnpj"
            header="CNPJ/CPF"
            body={row => <Cnpj>{row.cnpj}</Cnpj>}
            style={{ width: 160 }}
          />
          <Column field="city" header="Cidade" style={{ width: 140 }} />
          <Column field="state" header="Estado" style={{ width: 80 }} />
        </CustomDataTable>

        <div className="ocorrencias-entrega__modal-footer">
          <Btn onClick={() => onSave(clienteSelecionado)}>Salvar</Btn>
        </div>
      </div>
    </CustomModal>
  )
}

function createOcorrenciaModalState() {
  return {
    visible: false,
    row: null,
    selectedOcorrencia: null,
    observacao: '',
    selectedClient: null,
    showClientModal: false,
  }
}

const ConnectedOcorrenciasEntrega = connect()(OcorrenciasEntrega)

/**
 * Modal com o mesmo conteúdo da aba "Ocorrências Entrega" do Painel de Monitoramento de Entregas.
 */
export function ModalOcorrenciasEntrega({
  visible,
  deliveryStepVehicleId,
  fleetId,
  identifier,
  onClose,
}) {
  return (
    <CustomModal
      isVisible={visible}
      header={identifier ? `Ocorrências Entrega - ${identifier}` : 'Ocorrências Entrega'}
      width="min(1024px, 94vw)"
      onClose={onClose}
    >
      <div className="ocorrencias-entrega__modal-content">
        {visible && (
          <ConnectedOcorrenciasEntrega
            key={deliveryStepVehicleId}
            deliveryStepVehicleId={deliveryStepVehicleId}
            fleetId={fleetId}
          />
        )}
      </div>
    </CustomModal>
  )
}

export default ConnectedOcorrenciasEntrega
